<template>
    <div>

        <aside :class="['cart-right-side-desktop', {'sticky-cart' : addSticky}]" v-if="hasProduct && updateCartLoading == false">

            <!-- Cart Sidebar content goes here -->
            <div class="cart-sidebar-content">
                <h4 class="cs-main-title main-title">{{ $t("Cart Summary") }}</h4>
                <div class="cs-product-main-container" v-if="hasProduct && updateCartLoading == false">
                    <p class="cs-sub-title clear-both clearfix">
                      <span class="float-left">{{ $t("Products") }}</span>
                      <span class="right-flag float-right">
                          <img style="height: 50px;" :src="base_url+'images/cart-popup/flag_cart_'+currentLang+'.png'">
                      </span>
                    </p>
                    <div v-for="(product, p_index) in live_cart.products" :key="p_index" class="cs-product-container-d">
                        <b-card>
                            <b-row no-gutters>
                                <b-col>
                                    <div class="cs-product-image-container">
                                      <img :src="setImage(product.images)" alt="Image" />
                                    </div>
                                </b-col>

                                <b-col cols="9">
                                    <p>{{ product.name }}</p>
                                    <span class="rc-label float-right pr-3" v-if="product.is_recycled == '0'"><img class="rc-icon" src="../../public/images/recycling_icon.png" /><span class="rc-label-span">{{ $t('Recycling fee included') }}</span></span>
                                </b-col>
                            </b-row>
                            <div class="row price-information no-gutters">
                                <div class="col"><small class="font-14 font-italic">{{setCurrency(product.net_price_with_rc)}}</small> <b> x </b> <small class="font-14">{{product.line_item.quantity}} {{ $t('unit') }} </small></div>
                                <div class="col text-right"><span class="font-14">{{$t('Total')}} : </span><small class="font-14 font-italic font-weight-bold pricedata">{{ setCurrency(product.net_price_with_rc * product.line_item.quantity) }}</small></div>
                            </div>
                        </b-card>
                    </div>
                </div>

                <div v-if="live_cart.services">
                    <p class="cs-sub-title">{{ $t("Services") }}</p>
                    <div class="cs-service-container-d" v-for="(service, s_i) in live_cart.services"  :key="s_i">
                        <div class="row font-14" >
                            <div class="col-md-12">
                                <p class="m-0"> {{ service.name }} {{ service.size }}<span v-if="service.rim_size_id">&Prime;</span></p>
                                <p class="m-0">
                                  <span v-html="setCurrency(service.price)"></span> <b class="pl-1">x</b> {{ service.line_item.quantity}} {{ $t('unit') }}
                                  <span class="mb-0 font-weight-light text-right float-right"> {{$t('Total')}} : {{ setCurrency(service.sub_total) }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div v-else-if="filteredAdditionalServices.length">
                    <p class="cs-sub-title">{{ $t("Services") }} {{'2'}}</p>
                    <div class="cs-service-container-d" v-for="(ser, ser_key) in filteredAdditionalServices" :key="ser_key">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 pl-4">
                                        <small>{{ ser.service_name }}</small>
                                      <div class="float-right text-right"><small class="font-14 font-weight-light">{{$t('Total')}} : {{ setCurrency(ser.price) }}</small></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->

<!--                <div class="cs-single-entity-container" v-for="(lineItem, index) in orderDetails.line_items" :key="'charges-'+index" >
                    <div class="row" v-if="lineItem && (lineItem.type=='recycling_charges' || lineItem.type=='shipping_charges')">
                        <div class="col-8" v-if="lineItem && lineItem.type=='shipping_charges'">
                            <p class="mb-0">{{ $t('Shipping Charges') }}</p> First One Shipping
                        </div>
                        <div class="col-4" v-if="lineItem && lineItem.type=='shipping_charges'">
                            <p class="mb-0 text-right pricedata"><span v-html="setCurrency(lineItem.sub_total)"></span></p>
                        </div>
                    </div>
                </div>-->
                <div class="cs-single-entity-container" v-if="live_cart.shipping_charges >=0 ">
                    <div class="row font-14 mb-2">
                        <div class="col-md-12">
                          <p class="mb-0">
                              <span>{{ $t('Shipping charges') }}</span>
                              <span class="text-right float-right pricedata" v-html="setCurrency(live_cart.shipping_charges || '0.00')"></span>
                          </p>
                        </div>
                    </div>
                </div>
                <div class="cs-single-entity-container" v-if="live_cart.discount">
                    <div class="row font-14 mb-2">
                        <div class="col-md-12">
                            <p class="mb-0">
                              <span>{{ $t('Discount') }}</span>
                              <span class="text-right float-right pricedata" v-html="setCurrency(live_cart.discount)"></span>
                            </p>
                        </div>
                    </div>
                </div>

                <p class="mb-0 font-14 font-weight-bold cs-total-box" v-if="live_cart.totals">
                  {{ $t('Total ') }} :
                  <span class="float-right pricedata" v-html="setCurrency(live_cart.totals.total)"></span>
                </p>

                <div class="cs-single-entity-container" v-if="live_cart.totals">
                  <div class="row font-14 mb-2 mt-2">
                    <div class="col-md-12">
                      <p class="mb-0">
                        <span>{{ $t('Vat') }}</span>
                        <span class="text-right float-right pricedata" v-html="setCurrency(live_cart.totals.vat_amount)"></span>
                      </p>
                    </div>
                  </div>
                </div>

              <div class="cs-dealer-box" v-if="isNeedToShowNewDealer">
                <div class="row font-14 mb-0">
                  <div class="col-4">
                    <p class="mb-0">{{ $t('Dealer') }}</p>
                  </div>
                  <div class="col-8">
                    <p class="mb-0">{{ selectedServicePoint.company_name }}</p>
                  </div>
                </div>
                <div class="row font-14 mb-0">
                  <div class="col-4">
                    <p class="mb-0">{{ $t('Phone') }}</p>
                  </div>
                  <div class="col-8">
                    <p class="mb-0">{{ selectedServicePoint.contact_number }}</p>
                  </div>
                </div>
                <div class="row font-14 mb-0">
                  <div class="col-4">
                    <p class="mb-0">{{ $t('Email') }}</p>
                  </div>
                  <div class="col-8">
                    <p class="mb-0"> {{ selectedServicePoint.dealer_email }} </p>
                  </div>
                </div>
                <div class="row font-14 mb-0">
                  <div class="col-4">
                    <p class="mb-0">{{ $t('Address') }}</p>
                  </div>
                  <div class="col-8">
                    <p class="mb-0">{{ selectedServicePoint.address_line_1 + " " + (selectedServicePoint.address_line_2 || "") }}</p>
                    <p class="mb-0">{{ selectedServicePoint.city }}</p>
                  </div>
                </div>
                <div class="row font-14 mb-0" v-if="selectedServicePoint.time_slots.length === 0 && is_with_service">
                  <div class="col-12">
                    <p class="mb-0 pricedata">{{ $t("This service point doesn\'t have calendar, Please use contact details to take appointment for pickup and services.") }}</p>
                  </div>
                </div>
              </div>

                <div class="cs-dealer-box" v-if="getServicePointDetailsAccordingToService().name.length && !isNeedToShowNewDealer">
                    <div class="row font-14 mb-0">
                        <div class="col-4">
                            <p class="mb-0">{{ $t('Dealer') }}</p>
                        </div>
                        <div class="col-8">
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().name }}</p>
                        </div>
                    </div>
                    <div class="row font-14 mb-0">
                        <div class="col-4">
                            <p class="mb-0">{{ $t('Phone') }}</p>
                        </div>
                        <div class="col-8">
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().phone }}</p>
                        </div>
                    </div>
                    <div class="row font-14 mb-0">
                        <div class="col-4">
                            <p class="mb-0">{{ $t('Email') }}</p>
                        </div>
                        <div class="col-8">
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().email }}</p>
                        </div>
                    </div>
                    <div class="row font-14 mb-0" v-if="getServicePointDetailsAccordingToService().appointment.date && getServicePointDetailsAccordingToService().appointment.date != ''">
                        <div class="col-4">
                            <p class="mb-0">{{ $t('Date') }}</p>
                        </div>
                        <div class="col-8">
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().appointment.date | formatDate }}</p>
                        </div>
                    </div>
                    <div class="row font-14 mb-0" v-if="getServicePointDetailsAccordingToService().appointment.time && getServicePointDetailsAccordingToService().appointment.time != ''">
                        <div class="col-4">
                            <p class="mb-0">{{ $t('Time') }}</p>
                        </div>
                        <div class="col-8">
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().appointment.time }}</p>
                        </div>
                    </div>
                    <div class="row font-14 mb-0">
                        <div class="col-4">
                            <p class="mb-0">{{ $t('Address') }}</p>
                        </div>
                        <div class="col-8">
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().address }}</p>
                            <p class="mb-0">{{ getServicePointDetailsAccordingToService().city }}</p>
                        </div>
                    </div>
                    <div class="row font-14 mb-0" v-if="getServicePointDetailsAccordingToService().time_slots.length === 0">
                      <div class="col-12">
                        <p class="mb-0 pricedata">{{ $t("This service point doesn't have calendar, Please use contact details to take appointment for pickup and services.") }}</p>
                      </div>
                    </div>
                </div>
            </div>
        </aside>
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
    name: "CartRightSideDesktop",
    props: ["updateCartLoading", "hasProduct", 'calculatePrice', 'additionalServices', 'installationServiceStatus', 'shippingCharges', 'GrandTotal', 'cartDetails'],
    data: function () {
        return {
            filteredAdditionalServices : [],
            moneySign : "€",
            addSticky : false,
            base_url  : process.env.VUE_APP_BASE_URL
        };
    },
    computed : {
        ...mapGetters("app", ["currentLang"]),
        ...mapGetters('cart', ['cartProducts']),
        ...mapGetters('order', ['orderDetails', 'paymentDetails']),
        ...mapGetters('cart_right_sidebar', ['cs_dealer', 'cs_dealer_without_service', 'cs_loader', 'is_with_service', 'live_cart']),
        ...mapGetters('search_dealer', ['selectedServicePoint']),
        isNeedToShowNewDealer() {
          var r = false;
          if (this.selectedServicePoint !== null && this.is_with_service) {
            r = true
            if (this.cs_dealer.dealer_id != '' && this.selectedServicePoint.dealer_id === this.cs_dealer.dealer_id) {
              r = false
            }
          }
          return r
        }
    },
    methods: {
        ...mapActions('cart_right_sidebar', ['csSetDealerToLocalStorage', 'getLiveCart']),
        doFilterAdditionalService() {
            if ("service" in localStorage && localStorage.getItem("service")) {
              const savedServices = localStorage.getItem("service").split(',');
              const uniqueSet = new Set(savedServices);
              const uniqueService = Array.from(uniqueSet);
              const uniqueServiceAsNumber = uniqueService.map(Number);

              this.filteredAdditionalServices = this.additionalServices.filter(item => uniqueServiceAsNumber.includes(item.id));
            }
        },
        setCurrency(total) {
            if (total) {
                total = parseFloat(total).toFixed(2);
            }
            return total.replace(".", ",") + " " + this.moneySign;
        },
        getServiceName(service) {
            let serviceName = "";
            for (let [key, value] of Object.entries(service.translations)) {
                if (value.locale_code == this.currentLang) {
                    serviceName = value.name;
                }
            }

            return serviceName;
        },
        hasServices(lineItems) {
            const productIndex = _.findIndex(lineItems, function(lineItem)
                {
                    return lineItem.type == 'service';
                }
            );
            if(productIndex >0 ){
                return true
            }
            return false
        },
        handleScroll() {
            if(window.scrollY > 100) {
                this.addSticky = true;
            } else {
                this.addSticky = false;
            }
        },
        getServicePointDetailsAccordingToService() {
            if (this.is_with_service === true) {
              return this.cs_dealer;
            } else {
              return this.cs_dealer_without_service;
            }
        },
        setImage(ProductImages) {
          return (ProductImages && ProductImages.length != 0 && ProductImages != null) ? ProductImages[0].image_base_path+ProductImages[0].path:'/images/no-data-found.png'
        }
    },
    beforeMount() {
        this.csSetDealerToLocalStorage();
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        if (this.hasProduct && ['order-confirm', 'klarna-payment-status'].indexOf(this.$route.name) === -1) {
          this.getLiveCart()
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    filters: {
        formatDate(value) {
            const date = new Date(value);
            const day = date.getDate().toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        },
    },
    watch : {
        additionalServices : {
            immediate : true,
            handler() {
                this.doFilterAdditionalService();
            }
        },
        installationServiceStatus : {
            immediate : true,
            handler() {
                this.doFilterAdditionalService();
            }
        },
      currentLang: {
        handler() {
          if (this.hasProduct) {
            this.getLiveCart();
          }
        },
      }
    },
    created() {}
}
</script>

<style>
.cs-total-box {
    background: #d99c26;
    padding: 5px;
    color: #fff;
    border-radius: 5px;
}
.cs-total-box span {
    color : #fff;
}
.cart-right-side-desktop {
    background-color: #ffffff;
    box-shadow: 0px 0px 5px #d99c26;
    padding: 10px;
}

.cs-dealer-box {
    border : 1px solid #d99c26;
    padding: 5px;
    border-radius: 5px;
    margin-top: 5px;
}
.cs-dealer-box .col-4 p{
    font-size: 12px;
    font-weight: bold;
}
.cs-dealer-box .col-8 p{
    font-size: 12px;
    font-style: italic;
}
.cs-product-main-container {
    max-height: 355px;
    overflow-y: auto;
}
.cs-main-title {
    color: #fff;
    font-size: 15px;
    background: #d99c26;
    padding: 5px;
}

.cs-product-container-d, .cs-service-container-d {
    margin-bottom: 0.5em;
    padding-bottom: 0.5em;
    border : 1px solid #d99c26;
    border-radius: 5px;
    word-break: break-all;
}
.cs-service-container-d {
    padding: 5px;
}
.cs-sub-title {
    margin-bottom: 0.5rem;
}
.cs-product-container-d .card-img{
    padding: 5px 2px 2px;
}
.cs-product-container-d .price-information{
    padding: 5px;
}
.cs-product-container-d .col-9 p:nth-child(1) {
    margin-bottom: 5px;
    margin-top: 5px;
}
.cs-product-container-d .col-9 span:nth-child(2){
    font-size: 11px !important;
    font-style: italic;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
}

.cs-product-container-d .col-9 p:nth-child(2) img {
    width: 15px !important;
    height: 15px !important;
}

.cs-main-title.main-title .right-flag {
    position: absolute;
    right: 0;
    top: 0;
}

.cs-product-main-container::-webkit-scrollbar {
  width: 6px; /* Width of the scrollbar */
}

.cs-product-main-container::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 3px; /* Rounded corners for the thumb */
}

.cs-product-main-container::-webkit-scrollbar-track {
  background-color: transparent; /* Background behind the scrollbar */
}

.cs-product-image-container {
  width: 100%;
  height: 120px;
  justify-content: center;
  display: flex;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  flex: 0 0 100px;
  box-sizing: border-box;
  margin-right: 10px;
}

.cs-product-image-container img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.3s ease-in-out;
}
@media screen and (min-width: 999px){
    .sticky-cart {
        position: fixed;
        top: 130px;
        max-width: 350px;
        z-index: 1;
        max-height: 500px;
        overflow-y: auto;
        overflow-x: clip;
    }

    /* Custom scrollbar */
    .sticky-cart::-webkit-scrollbar {
        width: 6px; /* Width of the scrollbar */
    }

    .sticky-cart::-webkit-scrollbar-thumb {
        background-color: #888; /* Color of the scrollbar thumb */
        border-radius: 3px; /* Rounded corners for the thumb */
    }

    .sticky-cart::-webkit-scrollbar-track {
        background-color: transparent; /* Background behind the scrollbar */
    }
}
@media screen and (max-width: 991px) {
    .cart-right-side-desktop {
        /*margin-top: 25px;*/
        box-shadow: none !important;
        border: 1px solid #e2e2e2;
        padding: 5px;
    }
    .cs-main-title {
        font-size: 1.5em;
        text-align: center;
        display: none;
    }
    .cs-product-image-container {
        height: 90px;
    }
    .cs-product-container-d .card,.cs-service-container-d .card {
        border: 0 !important;
    }
    .cs-product-container-d, .cs-service-container-d {
        border-width: 1px 0px !important;
        border-color: #e2e2e2 !important;
    }

    .cs-product-container-d .col-9 p:first-child {
        font-size: 16px;
        margin-bottom: 0;
        padding-left: 0.8rem;

    }
    .cs-product-container-d .font-14, .cs-service-container-d small, .cs-service-container-d .pricedata {
        font-size: 17px !important;
        color: #000000;
        font-weight: 400 !important;
    }

    .cs-single-entity-container .pricedata {
        color: #000000;
        font-weight: 400 !important;
    }

    .cs-sub-title {
        background: #e3e3e3;
        padding: 5px 10px;
    }

    .cs-product-container-d, .cs-service-container-d {
        border-radius: 0!important;
    }
    .cs-total-box, .cs-single-entity-container, .cs-service-container-d, .cs-dealer-box {
        padding-left: 25px;
        padding-right: 25px;
    }
    .cs-total-box {
        border-radius: 0;
        padding-top: 5px;
        padding-bottom: 5px;
        background: #e3e3e3;
        color: #000000;
        font-size: 17px !important;
    }
    .cs-single-entity-container {
        padding-top: 2px;
        padding-bottom: 2px;
        background: #e2e2e2;
    }
    .cs-total-box .float-right.pricedata {
        font-size: 17px;
        color: #000000;
    }
    .cs-dealer-box {
        border: 1px solid #e2e2e2;
        border-radius: 0;
    }

    .cs-main-title.main-title {
        position: unset;
        margin-bottom: 0;
    }

    .cs-main-title.main-title .right-flag {
        position: unset;
    }
}

@media screen and (max-width: 375px) {
    .cs-product-container-d .card-body, .cs-service-container-d .card-body {
        padding: 0.5rem;
    }
    .cart-right-side-desktop {
        margin-top: 15px;
    }
    .cs-main-title {
        font-size: 1.3rem !important;
    }
    .cs-sub-title {
        font-size: 14px;
    }
    .cs-product-image-container {
      height: 70px;
    }
    .cs-product-container-d .col-9 small {
        font-size: 16px;
    }
    .cs-product-container-d .font-14, .cs-service-container-d small, .cs-service-container-d .col-3 p {
        font-size: 14px !important;
    }
    .cs-total-box .float-right.pricedata{
        font-size: 14px;
    }
    .cs-product-container-d .col-9 p:first-child {
        font-size: 15px;
    }
}
</style>